import table from "assets/images/chart-images/table.png";

const editors = [
    { id: "TCDLR#AE-T97r", name: "simple-bar", chartImage: table, v2: "Column", disabled: false, description: "AVERAGE" },
];

export default editors;